import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Booking() {
  const navigate = useNavigate();

  // State to store form data
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    branch: "Hinjewadi",
    phoneNumber: "",
    address: "",
  });

  // State to store validation errors
  const [errors, setErrors] = useState({});

  // Update state when form inputs change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Validate form data
  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }
    if (!formData.branch.trim()) {
      newErrors.branch = "Branch selection is required";
    }
    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits";
    }
    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    }
    if (!formData.pickupTime) {
      newErrors.pickupTime = "Pickup time selection is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const handleNumber = () => {
    if (formData.branch === "Wakad") return 8408842494;
    if (formData.branch === "Sakre Wasti") return 9044455050;
    if (formData.branch === "Hinjewadi") return 7387804606;
    if (formData.branch === "Mukainagar") return 7066455050;
  };

  // Handle the Proceed click
  const handleProceedClick = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // Do not proceed if validation fails
    }

    // Gather message with form data
    const message = `Hello, my name is ${formData.firstName} ${formData.lastName}, and I would like to schedule a pickup. My address is : ${formData.address}, nearest branch :${formData.branch}. Pickup time: ${formData.pickupTime}. My phone number is ${formData.phoneNumber}.`;
    const branchNumber = handleNumber();
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://api.whatsapp.com/send?phone=+91${branchNumber}&text=${encodedMessage}`;

    // Redirect to WhatsApp with pre-filled message
    window.open(whatsappURL, "_blank");

    // Optionally navigate to a different page after submission
    navigate("/");
  };

  return (
    <div className="w-full h-full bg-[#0fbfe6] font-[Montserrat]">
      <div className="isolate bg-[#0fbfe6] px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl font-[Montserrat]">
            Schedule Delivery
          </h2>
          <p className="mt-2 text-lg leading-8 text-white">
            You will be navigated to WhatsApp, just hit the send button please
            :)
          </p>
        </div>

        <form onSubmit={handleProceedClick} className="mx-auto mt-10 max-w-xl">
          <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
            {/* First Name */}
            <div>
              <label
                htmlFor="first-name"
                className="block text-sm font-semibold leading-6 text-white"
              >
                First name
              </label>
              <div className="mt-2.5">
                <input
                  id="first-name"
                  name="firstName"
                  type="text"
                  placeholder="Spinjoy"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  autoComplete="given-name"
                  className={`block w-full rounded-md border-0 px-3.5 py-2 text-[#000] shadow-sm ring-1 ring-inset ${errors.firstName ? "ring-red-500" : "ring-gray-300"
                    } placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                />
                {errors.firstName && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.firstName}
                  </p>
                )}
              </div>
            </div>

            {/* Last Name */}
            <div>
              <label
                htmlFor="last-name"
                className="block text-sm font-semibold leading-6 text-white"
              >
                Last name
              </label>
              <div className="mt-2.5">
                <input
                  id="last-name"
                  name="lastName"
                  type="text"
                  placeholder="Laundromat"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  autoComplete="family-name"
                  className={`block w-full rounded-md border-0 px-3.5 py-2 text-[#000] shadow-sm ring-1 ring-inset ${errors.lastName ? "ring-red-500" : "ring-gray-300"
                    } placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                />
                {errors.lastName && (
                  <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
                )}
              </div>
            </div>

            {/* Branch Selection */}
            <div className="sm:col-span-2">
              <label
                htmlFor="branch"
                className="block text-sm font-semibold leading-6 text-white"
              >
                Select the nearest Spinjoy Branch:
              </label>
              <select
                id="branch"
                name="branch"
                value={formData.branch}
                onChange={handleInputChange}
                className={`block w-full rounded-md border-0 px-3.5 py-2 text-[#000] shadow-sm ring-1 ring-inset ${errors.branch ? "ring-red-500" : "ring-gray-300"
                  } placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
              >
                <option value="">Select branch</option>
                <option value="Hinjewadi">Shinde Wasti, Hinjewadi</option>
                <option value="Sakre Wasti">Sakhare Vasti(Blue Ridge)</option>
                <option value="Wakad">Wakad</option>
                <option value="Mukainagar">Mukainagar</option>
              </select>
              {errors.branch && (
                <p className="text-red-500 text-xs mt-1">{errors.branch}</p>
              )}
            </div>

            {/* Phone Number */}
            <div className="sm:col-span-2">
              <label
                htmlFor="phone-number"
                className="block text-sm font-semibold leading-6 text-white"
              >
                Phone number
              </label>
              <div className="relative mt-2.5">
                <input
                  id="phone-number"
                  name="phoneNumber"
                  type="number"
                  maxLength={10}
                  placeholder="9999999999"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  autoComplete="tel"
                  className={`block w-full rounded-md border-0 px-3.5 py-2 text-[#000] shadow-sm ring-1 ring-inset ${errors.phoneNumber ? "ring-red-500" : "ring-gray-300"
                    } placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                />
                {errors.phoneNumber && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.phoneNumber}
                  </p>
                )}
              </div>
            </div>

            {/* Address */}
            <div className="sm:col-span-2">
              <label
                htmlFor="address"
                className="block text-sm font-semibold leading-6 text-white"
              >
                Address
              </label>
              <div className="mt-2.5">
                <textarea
                  id="address"
                  name="address"
                  rows={4}
                  value={formData.address}
                  onChange={handleInputChange}
                  className={`block w-full rounded-md border-0 px-3.5 py-2 text-[#000] shadow-sm ring-1 ring-inset ${errors.address ? "ring-red-500" : "ring-gray-300"
                    } placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                  placeholder="Detailed address"
                />
                {errors.address && (
                  <p className="text-red-500 text-xs mt-1">{errors.address}</p>
                )}
              </div>
            </div>
            {/* Address */}
            <div className="sm:col-span-2">
              <label className="block text-sm font-semibold leading-6 text-white">
                Select Pickup Time
              </label>
              <div className="mt-2.5 flex gap-4">
                <label className="flex items-center text-white">
                  <input
                    type="radio"
                    name="pickupTime"
                    value="10am - 1pm"
                    checked={formData.pickupTime === "10am - 1pm"}
                    onChange={handleInputChange}
                    className="mr-2"
                  />
                  10am To 1pm
                </label>
                <label className="flex items-center text-white">
                  <input
                    type="radio"
                    name="pickupTime"
                    value="5pm - 9pm"
                    checked={formData.pickupTime === "5pm - 9pm"}
                    onChange={handleInputChange}
                    className="mr-2"
                  />
                  5pm To 9pm
                </label>
              </div>
              {errors.pickupTime && (
                <p className="text-red-500 text-xs mt-1">{errors.pickupTime}</p>
              )}
            </div>
          </div>

          {/* Proceed Button */}
          <div className="mt-10">
            <button
              type="submit"
              className="block w-full rounded-md bg-[#FFF] px-3.5 py-2.5 text-center text-sm font-semibold text-[#0fbfe6] shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              PROCEED
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
